/** Показ тостов и всплывающих статусов с SignalR-хаба уведомлений (не отключает само соединение). */
export const WS_NOTIFICATIONS_TOASTS_STORAGE_KEY = 'pokolenie_ws_notifications_toasts_enabled';

export function areWsNotificationsToastsEnabled(): boolean {
  if (typeof window === 'undefined' || !window.localStorage) {
    return true;
  }
  const v = window.localStorage.getItem(WS_NOTIFICATIONS_TOASTS_STORAGE_KEY);
  if (v === null || v === '') {
    return true;
  }
  return v === '1' || v === 'true';
}

export function setWsNotificationsToastsEnabled(enabled: boolean): void {
  if (typeof window === 'undefined' || !window.localStorage) {
    return;
  }
  window.localStorage.setItem(WS_NOTIFICATIONS_TOASTS_STORAGE_KEY, enabled ? '1' : '0');
}

export function toggleWsNotificationsToastsEnabled(): boolean {
  const next = !areWsNotificationsToastsEnabled();
  setWsNotificationsToastsEnabled(next);
  return next;
}
